export default "__VITE_ASSET__CdniK$NW__"